import React, { Fragment, useState, useRef, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { MaskEditForm } from "./MaskEditForm";
import { db } from "../../../../firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { notifyTopRight, notifyError } from "../../toast/SetToast";
import Toast from "../../toast/SetToast";
import { useFirestore } from "../../../../hook/useFirestore";
const MaskEdit = ({ mask, show, onHide, onUpdate }) => {
  const { updateDocument } = useFirestore("masks");
  const inputRef = useRef({
    maskName: "",
    price: "",
    description: "",
    IsActive: "",
  });

  const handleChange = (name) => (e) => {
    inputRef.current[name] = e.target.value;
    console.log(inputRef.current);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      maskName: inputRef.current.maskName
        ? inputRef.current.maskName
        : mask.maskName,
      price: inputRef.current.price ? inputRef.current.price : mask.price,
      description: inputRef.current.description
        ? inputRef.current.description
        : mask.description,
      IsActive: inputRef.current.IsActive
        ? inputRef.current.IsActive
        : mask.IsActive,
    };
    console.log(formData);

    updateDocument(mask.id, formData)
      .then(() => {
        notifyTopRight("บันทึกข้อมูลสำเร็จ");
      })
      .catch((err) => {
        notifyError("บันทึกข้อมูลผิดพลาด ", err);
      });

    onHide();

    inputRef.current.maskName = "";
    inputRef.current.price = "";
    inputRef.current.description = "";
    inputRef.current.IsActive = "";
  };

  return (
    <Fragment>
      <Toast />
      <Modal className="fade" show={show} onHide={onHide} centered>
        <Modal.Header>
          <Modal.Title>Edit Mask</Modal.Title>
          <Button variant="" className="close" onClick={onHide}>
            <span>&times;</span>
          </Button>
        </Modal.Header>
        <Modal.Body>
          <MaskEditForm onChange={handleChange} initailValues={mask} />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
        <div className="d-flex justify-content-center mb-3">
          <Button className="sm" onClick={handleSubmit}>
            Save
          </Button>

          <Button className="sm ml-2" variant="light" onClick={onHide}>
            Cancel
          </Button>
        </div>
      </Modal>
    </Fragment>
  );
};

export default MaskEdit;
